import React,{ Component } from 'react'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import { getProductos } from '../actions'
import Producto from '../components/prodlistamod'
import ProductoHeader from '../components/productoheader'
import ProductoDescripcion from '../components/productodesc'
import ProductoEjemplos from '../components/productoejemplos'
import ProductoCustom from '../components/productocustom'

import ProductosListaHead from '../components/productoListaHead'

class ProductoListaDirect extends Component{

  constructor(props) {
    super(props);
    this.state = {
      imgPrefix:"",
      rubro:0,
      categoria:0
    }
  }

  componentDidMount() {
      this.setState({
        rubro:this.props.rubro,
        categoria:this.props.categoria
      })
      /*if(this.state.categoria && this.state.categoria != ""){
        console.log("va a traer categoria"+this.state.categoria)
        this.props.getProductos(this.state.rubro,this.state.categoria)
      }else{
        this.props.getProductos(this.state.rubro,0)
      }*/
  }
  
  componentDidUpdate(prevProps, prevState){
    //console.log(this.props.categorias)
    if(this.props.categoria != prevState.categoria){ 
      this.setState({
        rubro:this.props.rubro,
        categoria:this.props.categoria
      })
      this.props.getProductos(this.props.categoria)
    }

  }

  render() {
      //console.log(this.props)
      if(!this.props.productos){
        return <div>CARGANDO</div>
      }
      var rubroSelect = this.props.menu.opciones.filter(o => {
        if(parseInt(o.id) === parseInt(this.props.rubro)){
          return o;
        }
      });

      const catSelect = this.props.categorias.find((cat) => {
        return cat.id === this.state.categoria
      })
            
      //if(this.props.productos.length>0 && parseInt(this.props.productos[0].rubro.id) !== 1 && parseInt(this.props.productos[0].rubro.id) !== 3){
      if (catSelect && !catSelect.venta_online){
        //console.log("VENTA ONLINE OFF")
        return <ProductosListaHead datos={rubroSelect}  categoria={this.props.categoria}/>
      }

      var custom=0
      /*if(this.state.rubro == 1 || this.state.rubro==2 || this.state.rubro==3){
        custom=1
      }*/

      const  listaProductos = this.props.productos.map((producto,i)=>{
          var data = Object.assign({},producto);
          return <Producto key={i} producto={producto} />
      })
      //<ProductoHeader/>

      return (
        <section>
          { this.props.productos[0]   &&
          <ProductoHeader productos={this.props.productos} ubicacion="lista"/>
          }
          <div className="container">
            <div className="row p-3">
              { listaProductos !=null  &&
                    listaProductos 
              }
            </div>
            <ProductoDescripcion rubro={this.state.rubro} categoria={this.state.categoria}/>
          </div> 
          { custom == 1  &&
          <ProductoCustom/>
          }
        </section>
		  )
    }
}
const mapStateToProps = (state, ownProps) => {
  return {
      productos: state.productos.lista,
      categorias: state.menu.flias,
      menu:state.menu
    }
}

const mapDispatchToProps = dispatch => {
  return {
    getProductos: (rubro, categoria) => {
      dispatch(getProductos(rubro,categoria))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductoListaDirect);




// WEBPACK FOOTER //
// ./src/components/prodlistadirect.js